import React from 'react'

interface Props {
  url: string | null
}

const Avatar: React.FC<Props> = ({ url }) => {
  if (!url) return null
  return <img alt="avatar" src={url} className="h-full rounded-full mr-2 w-10" />
}

export default Avatar
